import { Injectable } from '@angular/core';
import { IS1SearchParams, S1HttpClientService } from '@app/s1/s1-http-client.service';
import { Observable, map } from 'rxjs';
import { CheckType, IBaseOption } from '../models/models';

export interface ISearchParteParams extends IS1SearchParams {
  parte: string
}

@Injectable({
  providedIn: 'root'
})
export class PartiService {

  path = "/parti";

  constructor(private s1HttpClient: S1HttpClientService) { }

  getParti(parameters: ISearchParteParams, type: CheckType, ui: boolean = false): Observable<IBaseOption[]> {
    return this.s1HttpClient.get(`/${type}${this.path}`, parameters, ui).pipe(
      map(response => response.data.results)
    )
  }
}
